module.exports = __webpack_public_path__ + "5bb09cd0e2090ebab5fa23d02d3a3033.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/common/bookCovers/book3.png
 ** module id = 835
 ** module chunks = 0
 **/